/** DOCUMENTUL ARHITECTURII pentru hârtia de calc a editorului
 *  (`calcArhitectura`): cerut o singură dată, la prima aprindere a planului,
 *  și ținut cât stă editorul deschis (`cerere.useCerut`). Vine cu ACEEAȘI
 *  orientare ca în vizualizator — întors o dată, la citire (`northUp`);
 *  originea locală o scade cine desenează. */
import { solutionDocument } from "../api";
import { northUp, type CanonicalDoc } from "../viewer/canonical";
import { useCerut, type StareCerere } from "./cerere";

export type StareDocument = StareCerere;
export type DocumentArhitectura = { doc: CanonicalDoc | null; stare: StareDocument };

/** Documentul arhitecturii `arhitectura` a proiectului `projectId`, cerut
 *  când `pornit` e adevărat prima dată; `stare` spune dacă e pe drum sau
 *  dacă n-a putut fi citit. */
export function useDocumentArhitectura(projectId: string, arhitectura: string,
                                       pornit: boolean): DocumentArhitectura {
  const { val, stare } = useCerut<CanonicalDoc>(
    pornit ? `${projectId}/${arhitectura}` : null,
    () => solutionDocument(projectId, arhitectura)
      .then((d) => northUp(d as unknown as CanonicalDoc)));
  return { doc: val, stare };
}
